import queryString from "query-string";
import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { values } from "lodash";

import BouncingLoader from "components/EnergyCompany/BouncingLoader/BouncingLoader.jsx";
import Alerts from "components/EnergyCompany/Alert/Alerts";
import Button from "components/CustomButtons/Button.jsx";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { authenticateUser } from "reducers/user/actions";
import { confirmacaoConvite } from "services/auth";
import { getFromAtob } from "services/utils";
import { showAlert } from "reducers/alerts/actions";

const styles = {
  buttons: {
    display: "flex",
    margin: "20px 0",
  },
  confirmarBtn: {
    marginRight: "10px",
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  titleActions: {
    color:  "#3C4858",
    display: "flex",
    fontSize: "2.6em",
    justifyContent: "center",
  },
};

class ConfirmacaoConvitePage extends Component {
  state = {
    loading: false,
    msg: "",
  };

  confirmacaoConvite = resposta => {
    const { authenticateUser, history, location } = this.props;
    const { codigo, id, idAssinatura } = queryString.parse(location.search);

    this.setState({ loading: true });

    confirmacaoConvite({ codigo, id, idAssinatura, resposta })
      .then(({ data }) => {
        this.setState({ msg: "Redirecionando para o dashboard." });
        authenticateUser(data);

        setTimeout(() => {
          history.push("/dashboard");
        }, 2000);
      })
      .catch(({ response }) => {
        this.setState({ cadastrando: false, loading: false });
        this.props.showAlert({ message: values(response.data).join(" "), type: 'error' });
      });
  }

  render() {
    const { classes, location } = this.props;
    const { loading, msg } = this.state;
    const [nomeAssinatura] = getFromAtob([queryString.parse(location.search)]);

    return (
      <div className={classes.container}>
        <GridContainer alignContent="center" justify="center">
          <GridItem md={10} sm={12} xs={12}>
            <ECCard
              content={
                <div className={classes.contentWrapper}>
                  <h4>Você foi convidado para fazer da assinatura de <b>{atob(nomeAssinatura)}</b>.</h4>
                  {loading ? (
                    <BouncingLoader />
                  ) : (
                    <div className={classes.buttons}>
                      <Button
                        className={classes.confirmarBtn}
                        color="rose"
                        onClick={() => this.confirmacaoConvite(false)}
                        round
                      >
                        Recusar
                      </Button>
                      <Button
                        color="info"
                        onClick={() => this.confirmacaoConvite(true)}
                        round
                      >
                        Confirmar
                      </Button>
                    </div>
                  )}
                  <h4>{msg}</h4>
                </div>
              }
              title="Aceitar ou recusar convite"
              titleActionsClass={classes.titleActions}
            />
          </GridItem>
        </GridContainer>
        <Alerts />
      </div>
    );
  }
}

ConfirmacaoConvitePage.propTypes = {
  authenticateUser: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  showAlert: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  authenticateUser,
  showAlert,
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(ConfirmacaoConvitePage));



// WEBPACK FOOTER //
// ./src/views/Pages/ConfirmacaoConvitePage.jsx